export default __webpack_public_path__ + "static/media/img3.81e9f59e.PNG";